export default __webpack_public_path__ + "static/media/mus-oakisland.5406a50f.mp4";